import { render, staticRenderFns } from "./org-user-list.vue?vue&type=template&id=33f47fba&scoped=true&"
import script from "./org-user-list.vue?vue&type=script&lang=js&"
export * from "./org-user-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f47fba",
  null
  
)

export default component.exports